import { zip } from "@/fp";
import {
  PermissionMainType,
  PermissionSubType,
  PermissionTypeHelper,
} from "./models";

const BASE_OWNERS = [
  "cao@cognnipolicies.onmicrosoft.com",
  "michael@cognnipolicies.onmicrosoft.com",
  "omri@cognnipolicies.onmicrosoft.com",
  "shaham@cognnipolicies.onmicrosoft.com",
  "tomer@cognnipolicies.onmicrosoft.com",
  "User@cognnipolicies.onmicrosoft.com",
];

const OWNERS = Array(200)
  .fill({})
  .map(() => {
    return BASE_OWNERS[Math.floor(Math.random() * 6)];
  });

const PUBLIC_SITES = [
  "https://cognniautomations-my.sharepoint.com/operationshub",
  "https://cognniautomations-my.sharepoint.com/processcenter",
  "https://cognniautomations-my.sharepoint.com/logisticsportal",
  "https://cognniautomations-my.sharepoint.com/inventorycontrol",
  "https://cognniautomations-my.sharepoint.com/supplychainhq",
  "https://cognniautomations-my.sharepoint.com/financecenter",
  "https://cognniautomations-my.sharepoint.com/projectmanagement",
  "https://cognniautomations-my.sharepoint.com/humanresources",
  "https://cognniautomations-my.sharepoint.com/salesdashboard",
  "https://cognniautomations-my.sharepoint.com/customerrelations",
  "https://cognniautomations-my.sharepoint.com/qualityassurance",
  "https://cognniautomations-my.sharepoint.com/procurementportal",
  "https://cognniautomations-my.sharepoint.com/productioncontrol",
  "https://cognniautomations-my.sharepoint.com/strategicplanning",
  "https://cognniautomations-my.sharepoint.com/dataanalytics",
  "https://cognniautomations-my.sharepoint.com/financialreporting",
  "https://cognniautomations-my.sharepoint.com/operationsefficiency",
  "https://cognniautomations-my.sharepoint.com/workforcemanagement",
  "https://cognniautomations-my.sharepoint.com/supplychainmanagement",
  "https://cognniautomations-my.sharepoint.com/corporatecommunications",
  "https://cognniautomations-my.sharepoint.com/businessdevelopment",
  "https://cognniautomations-my.sharepoint.com/servicedelivery",
  "https://cognniautomations-my.sharepoint.com/strategicmanagement",
  "https://cognniautomations-my.sharepoint.com/operationalriskmanagement",
  "https://cognniautomations-my.sharepoint.com/customerexperience",
  "https://cognniautomations-my.sharepoint.com/workflowautomation",
  "https://cognniautomations-my.sharepoint.com/salesoperations",
  "https://cognniautomations-my.sharepoint.com/suppliermanagement",
  "https://cognniautomations-my.sharepoint.com/operationsanalytics",
  "https://cognniautomations-my.sharepoint.com/employeetraining",
  "https://cognniautomations-my.sharepoint.com/strategicplanner",
  "https://cognniautomations-my.sharepoint.com/performanceevaluation",
  "https://cognniautomations-my.sharepoint.com/supplychainoptimization",
  "https://cognniautomations-my.sharepoint.com/costmanagement",
  "https://cognniautomations-my.sharepoint.com/operationsplanning",
  "https://cognniautomations-my.sharepoint.com/productionmanagement",
  "https://cognniautomations-my.sharepoint.com/operationssupport",
  "https://cognniautomations-my.sharepoint.com/financialmanagement",
  "https://cognniautomations-my.sharepoint.com/businessanalysis",
  "https://cognniautomations-my.sharepoint.com/qualitycontrol",
  "https://cognniautomations-my.sharepoint.com/supplychainplanning",
  "https://cognniautomations-my.sharepoint.com/operationsresearch",
  "https://cognniautomations-my.sharepoint.com/workforceplanning",
  "https://cognniautomations-my.sharepoint.com/operationsexcellence",
  "https://cognniautomations-my.sharepoint.com/strategyexecution",
  "https://cognniautomations-my.sharepoint.com/operationstracking",
  "https://cognniautomations-my.sharepoint.com/operationsaudit",
  "https://cognniautomations-my.sharepoint.com/businessprocessmanagement",
  "https://cognniautomations-my.sharepoint.com/operationssolution",
  "https://cognniautomations-my.sharepoint.com/costreduction",
  "https://cognniautomations-my.sharepoint.com/supplychainvisibility",
  "https://cognniautomations-my.sharepoint.com/operationsexpertise",
  "https://cognniautomations-my.sharepoint.com/financialforecasting",
  "https://cognniautomations-my.sharepoint.com/operationsdashboard",
];

const PUBLIC_SITES_NAMES = [
  "Operations Hub",
  "Process Center",
  "Logistics Portal",
  "Inventory Control",
  "Supply Chain HQ",
  "Finance Center",
  "Project Management",
  "Human Resources",
  "Sales Dashboard",
  "Customer Relations",
  "Quality Assurance",
  "Procurement Portal",
  "Production Control",
  "Strategic Planning",
  "Data Analytics",
  "Financial Reporting",
  "Operations Efficiency",
  "Workforce Management",
  "Supply Chain Management",
  "Corporate Communications",
  "Business Development",
  "Service Delivery",
  "Strategic Management",
  "Operational Risk Management",
  "Customer Experience",
  "Workflow Automation",
  "Sales Operations",
  "Supplier Management",
  "Operations Analytics",
  "Employee Training",
  "Strategic Planner",
  "Performance Evaluation",
  "Supply Chain Optimization",
  "Cost Management",
  "Operations Planning",
  "Production Management",
  "Operations Support",
  "Financial Management",
  "Business Analysis",
  "Quality Control",
  "Supply Chain Planning",
  "Operations Research",
  "Workforce Planning",
  "Operations Excellence",
  "Strategy Execution",
  "Operations Tracking",
  "Operations Audit",
  "Business Process Management",
  "Operations Solution",
  "Cost Reduction",
  "Supply Chain Visibility",
  "Operations Expertise",
  "Financial Forecasting",
  "Operations Dashboard",
];

const PRIVATE_SITES = [
  "https://cognniautomations-my.sharepoint.com/operationstransformation",
  "https://cognniautomations-my.sharepoint.com/inventorymanagement",
  "https://cognniautomations-my.sharepoint.com/logisticsmanagement",
  "https://cognniautomations-my.sharepoint.com/workforceoptimization",
  "https://cognniautomations-my.sharepoint.com/supplychainintegration",
  "https://cognniautomations-my.sharepoint.com/supplychainvisibility",
  "https://cognniautomations-my.sharepoint.com/supplychainoptimization",
  "https://cognniautomations-my.sharepoint.com/operationsstrategy",
  "https://cognniautomations-my.sharepoint.com/operationsefficiency",
  "https://cognniautomations-my.sharepoint.com/operationsmanagement",
  "https://cognniautomations-my.sharepoint.com/operationsanalytics",
  "https://cognniautomations-my.sharepoint.com/operationsautomation",
  "https://cognniautomations-my.sharepoint.com/operationsplanning",
  "https://cognniautomations-my.sharepoint.com/operationsperformance",
  "https://cognniautomations-my.sharepoint.com/operationssupport",
  "https://cognniautomations-my.sharepoint.com/operationsreporting",
  "https://cognniautomations-my.sharepoint.com/operationscontrol",
  "https://cognniautomations-my.sharepoint.com/operationstracking",
  "https://cognniautomations-my.sharepoint.com/operationsaudit",
  "https://cognniautomations-my.sharepoint.com/operationsmonitoring",
  "https://cognniautomations-my.sharepoint.com/operationsdashboard",
  "https://cognniautomations-my.sharepoint.com/operationsoptimization",
  "https://cognniautomations-my.sharepoint.com/operationsplanner",
  "https://cognniautomations-my.sharepoint.com/operationsconsulting",
  "https://cognniautomations-my.sharepoint.com/operationsintelligence",
  "https://cognniautomations-my.sharepoint.com/operationsimplementation",
  "https://cognniautomations-my.sharepoint.com/operationsreview",
  "https://cognniautomations-my.sharepoint.com/operationstransparency",
  "https://cognniautomations-my.sharepoint.com/operationsassessment",
  "https://cognniautomations-my.sharepoint.com/operationsexecution",
  "https://cognniautomations-my.sharepoint.com/operationsinsights",
  "https://cognniautomations-my.sharepoint.com/operationsplanning",
  "https://cognniautomations-my.sharepoint.com/operationsscalability",
  "https://cognniautomations-my.sharepoint.com/operationsperformance",
  "https://cognniautomations-my.sharepoint.com/operationsworkflow",
  "https://cognniautomations-my.sharepoint.com/operationsalignment",
  "https://cognniautomations-my.sharepoint.com/operationsintegration",
  "https://cognniautomations-my.sharepoint.com/operationscollaboration",
  "https://cognniautomations-my.sharepoint.com/operationsenablement",
  "https://cognniautomations-my.sharepoint.com/operationsintelligence",
  "https://cognniautomations-my.sharepoint.com/operationsgovernance",
  "https://cognniautomations-my.sharepoint.com/operationsmanagement",
  "https://cognniautomations-my.sharepoint.com/operationsimprovement",
  "https://cognniautomations-my.sharepoint.com/operationssupport",
  "https://cognniautomations-my.sharepoint.com/operationsassessment",
  "https://cognniautomations-my.sharepoint.com/operationsmonitoring",
  "https://cognniautomations-my.sharepoint.com/operationsstrategy",
  "https://cognniautomations-my.sharepoint.com/operationsreview",
  "https://cognniautomations-my.sharepoint.com/operationsaudit",
  "https://cognniautomations-my.sharepoint.com/operationsplanning",
  "https://cognniautomations-my.sharepoint.com/operationsgovernance",
  "https://cognniautomations-my.sharepoint.com/operationsalignment",
  "https://cognniautomations-my.sharepoint.com/operationsintegration",
  "https://cognniautomations-my.sharepoint.com/operationscollaboration",
  "https://cognniautomations-my.sharepoint.com/operationsenablement",
  "https://cognniautomations-my.sharepoint.com/operationsintelligence",
  "https://cognniautomations-my.sharepoint.com/operationsimprovement",
  "https://cognniautomations-my.sharepoint.com/operationssupport",
  "https://cognniautomations-my.sharepoint.com/operationsassessment",
  "https://cognniautomations-my.sharepoint.com/operationsmonitoring",
  "https://cognniautomations-my.sharepoint.com/operationsstrategy",
  "https://cognniautomations-my.sharepoint.com/operationsreview",
  "https://cognniautomations-my.sharepoint.com/operationsaudit",
  "https://cognniautomations-my.sharepoint.com/operationsplanning",
  "https://cognniautomations-my.sharepoint.com/operationsgovernance",
  "https://cognniautomations-my.sharepoint.com/operationsalignment",
  "https://cognniautomations-my.sharepoint.com/operationsintegration",
  "https://cognniautomations-my.sharepoint.com/operationscollaboration",
  "https://cognniautomations-my.sharepoint.com/operationsenablement",
  "https://cognniautomations-my.sharepoint.com/operationsintelligence",
  "https://cognniautomations-my.sharepoint.com/operationsimprovement",
  "https://cognniautomations-my.sharepoint.com/operationssupport",
  "https://cognniautomations-my.sharepoint.com/operationsassessment",
  "https://cognniautomations-my.sharepoint.com/operationsmonitoring",
  "https://cognniautomations-my.sharepoint.com/operationsstrategy",
  "https://cognniautomations-my.sharepoint.com/operationsreview",
  "https://cognniautomations-my.sharepoint.com/operationsaudit",
  "https://cognniautomations-my.sharepoint.com/operationsplanning",
  "https://cognniautomations-my.sharepoint.com/operationsgovernance",
  "https://cognniautomations-my.sharepoint.com/operationsalignment",
  "https://cognniautomations-my.sharepoint.com/operationsintegration",
];

const PRIVATE_SITES_NAMES = [
  "Operations Transformation",
  "Inventory Management",
  "Logistics Management",
  "Workforce Optimization",
  "Supply Chain Integration",
  "Supply Chain Visibility",
  "Supply Chain Optimization",
  "Operations Strategy",
  "Operations Efficiency",
  "Operations Management",
  "Operations Analytics",
  "Operations Automation",
  "Operations Planning",
  "Operations Performance",
  "Operations Support",
  "Operations Reporting",
  "Operations Control",
  "Operations Tracking",
  "Operations Audit",
  "Operations Monitoring",
  "Operations Dashboard",
  "Operations Optimization",
  "Operations Planner",
  "Operations Consulting",
  "Operations Intelligence",
  "Operations Implementation",
  "Operations Review",
  "Operations Transparency",
  "Operations Assessment",
  "Operations Execution",
  "Operations Insights",
  "Operations Scalability",
  "Operations Workflow",
  "Operations Alignment",
  "Operations Integration",
  "Operations Collaboration",
  "Operations Enablement",
  "Operations Governance",
  "Operations Improvement",
  "Operations Support",
  "Operations Assessment",
  "Operations Monitoring",
  "Operations Strategy",
  "Operations Review",
  "Operations Audit",
  "Operations Planning",
  "Operations Governance",
  "Operations Alignment",
  "Operations Integration",
  "Operations Collaboration",
  "Operations Enablement",
  "Operations Intelligence",
  "Operations Improvement",
  "Operations Support",
  "Operations Assessment",
  "Operations Monitoring",
  "Operations Strategy",
  "Operations Review",
  "Operations Audit",
  "Operations Planning",
  "Operations Governance",
  "Operations Alignment",
  "Operations Integration",
  "Operations Collaboration",
  "Operations Enablement",
  "Operations Intelligence",
  "Operations Improvement",
  "Operations Support",
  "Operations Assessment",
  "Operations Monitoring",
  "Operations Strategy",
  "Operations Review",
  "Operations Audit",
  "Operations Planning",
  "Operations Governance",
  "Operations Alignment",
  "Operations Integration",
  "Operations Collaboration",
  "Operations Enablement",
  "Operations Intelligence",
  "Operations Improvement",
  "Operations Support",
  "Operations Assessment",
  "Operations Monitoring",
  "Operations Strategy",
  "Operations Review",
  "Operations Audit",
  "Operations Planning",
  "Operations Governance",
  "Operations Alignment",
  "Operations Integration",
  "Operations Collaboration",
  "Operations Enablement",
  "Operations Intelligence",
  "Operations Improvement",
  "Operations Support",
  "Operations Assessment",
  "Operations Monitoring",
  "Operations Strategy",
  "Operations Review",
  "Operations Audit",
  "Operations Planning",
  "Operations Governance",
  "Operations Alignment",
  "Operations Integration",
  "Operations Collaboration",
  "Operations Enablement",
  "Operations Intelligence",
  "Operations Improvement",
  "Operations Support",
];

const PRIVATE_MASS_EXPOSED_SITES = [
  "https://cognniautomations-my.sharepoint.com/hrpolicies",
  "https://cognniautomations-my.sharepoint.com/hrtraining",
  "https://cognniautomations-my.sharepoint.com/hrcompliance",
  "https://cognniautomations-my.sharepoint.com/hrdocuments",
  "https://cognniautomations-my.sharepoint.com/hrbenefits",
  "https://cognniautomations-my.sharepoint.com/hrhandbook",
  "https://cognniautomations-my.sharepoint.com/hrrecords",
  "https://cognniautomations-my.sharepoint.com/hrprocedures",
  "https://cognniautomations-my.sharepoint.com/hrforms",
  "https://cognniautomations-my.sharepoint.com/hrdirectory",
  "https://cognniautomations-my.sharepoint.com/hrmanagement",
  "https://cognniautomations-my.sharepoint.com/hranalytics",
  "https://cognniautomations-my.sharepoint.com/hrtrainingmaterials",
  "https://cognniautomations-my.sharepoint.com/hrrecruitment",
  "https://cognniautomations-my.sharepoint.com/hrperformance",
  "https://cognniautomations-my.sharepoint.com/hrdevelopment",
  "https://cognniautomations-my.sharepoint.com/hrportal",
  "https://cognniautomations-my.sharepoint.com/hrworkflow",
  "https://cognniautomations-my.sharepoint.com/hrcommunications",
  "https://cognniautomations-my.sharepoint.com/hrconsulting",
  "https://cognniautomations-my.sharepoint.com/hrstrategies",
  "https://cognniautomations-my.sharepoint.com/hrprograms",
  "https://cognniautomations-my.sharepoint.com/hrinitiatives",
  "https://cognniautomations-my.sharepoint.com/hrdevelopment",
  "https://cognniautomations-my.sharepoint.com/hrreports",
  "https://cognniautomations-my.sharepoint.com/hrmanagement",
  "https://cognniautomations-my.sharepoint.com/hrtraining",
  "https://cognniautomations-my.sharepoint.com/hrbenefits",
  "https://cognniautomations-my.sharepoint.com/hrpolicies",
  "https://cognniautomations-my.sharepoint.com/hrcompliance",
  "https://cognniautomations-my.sharepoint.com/hrprocedures",
  "https://cognniautomations-my.sharepoint.com/hrforms",
  "https://cognniautomations-my.sharepoint.com/hrrecords",
  "https://cognniautomations-my.sharepoint.com/hrdirectory",
  "https://cognniautomations-my.sharepoint.com/hrportal",
  "https://cognniautomations-my.sharepoint.com/hranalytics",
  "https://cognniautomations-my.sharepoint.com/hrtrainingmaterials",
  "https://cognniautomations-my.sharepoint.com/hrrecruitment",
  "https://cognniautomations-my.sharepoint.com/hrperformance",
  "https://cognniautomations-my.sharepoint.com/hrdevelopment",
  "https://cognniautomations-my.sharepoint.com/hrworkflow",
  "https://cognniautomations-my.sharepoint.com/hrcommunications",
  "https://cognniautomations-my.sharepoint.com/hrconsulting",
  "https://cognniautomations-my.sharepoint.com/hrstrategies",
  "https://cognniautomations-my.sharepoint.com/hrprograms",
  "https://cognniautomations-my.sharepoint.com/hrinitiatives",
  "https://cognniautomations-my.sharepoint.com/hrdevelopment",
  "https://cognniautomations-my.sharepoint.com/hrreports",
  "https://cognniautomations-my.sharepoint.com/financepolicies",
  "https://cognniautomations-my.sharepoint.com/financetraining",
  "https://cognniautomations-my.sharepoint.com/financecompliance",
  "https://cognniautomations-my.sharepoint.com/financedocuments",
  "https://cognniautomations-my.sharepoint.com/financebenefits",
  "https://cognniautomations-my.sharepoint.com/financehandbook",
  "https://cognniautomations-my.sharepoint.com/financerecords",
  "https://cognniautomations-my.sharepoint.com/financeprocedures",
  "https://cognniautomations-my.sharepoint.com/financeforms",
  "https://cognniautomations-my.sharepoint.com/financedirectory",
  "https://cognniautomations-my.sharepoint.com/financemanagement",
  "https://cognniautomations-my.sharepoint.com/financeanalytics",
  "https://cognniautomations-my.sharepoint.com/financetrainingmaterials",
  "https://cognniautomations-my.sharepoint.com/financerecruitment",
  "https://cognniautomations-my.sharepoint.com/financeperformance",
  "https://cognniautomations-my.sharepoint.com/financedevelopment",
  "https://cognniautomations-my.sharepoint.com/financeportal",
];

const PRIVATE_MASS_EXPOSED_SITES_NAMES = [
  "HR Policies",
  "HR Training",
  "HR Compliance",
  "HR Documents",
  "HR Benefits",
  "HR Handbook",
  "HR Records",
  "HR Procedures",
  "HR Forms",
  "HR Directory",
  "HR Management",
  "HR Analytics",
  "HR Training Materials",
  "HR Recruitment",
  "HR Performance",
  "HR Development",
  "HR Portal",
  "HR Workflow",
  "HR Communications",
  "HR Consulting",
  "HR Strategies",
  "HR Programs",
  "HR Initiatives",
  "HR Development",
  "HR Reports",
  "HR Management",
  "HR Training",
  "HR Benefits",
  "HR Policies",
  "HR Compliance",
  "HR Procedures",
  "HR Forms",
  "HR Records",
  "HR Directory",
  "HR Portal",
  "HR Analytics",
  "HR Training Materials",
  "HR Recruitment",
  "HR Performance",
  "HR Development",
  "HR Workflow",
  "HR Communications",
  "HR Consulting",
  "HR Strategies",
  "HR Programs",
  "HR Initiatives",
  "HR Development",
  "HR Reports",
  "Finance Policies",
  "Finance Training",
  "Finance Compliance",
  "Finance Documents",
  "Finance Benefits",
  "Finance Handbook",
  "Finance Records",
  "Finance Procedures",
  "Finance Forms",
  "Finance Directory",
  "Finance Management",
  "Finance Analytics",
  "Finance Training Materials",
  "Finance Recruitment",
  "Finance Performance",
  "Finance Development",
  "Finance Portal",
];

const PRIVATE_EXTERNALLY_EXPOSED = [
  "https://cognniautomations-my.sharepoint.com/legalprocedures",
  "https://cognniautomations-my.sharepoint.com/hrprocedures",
  "https://cognniautomations-my.sharepoint.com/financeprocedures",
  "https://cognniautomations-my.sharepoint.com/legalforms",
  "https://cognniautomations-my.sharepoint.com/hrforms",
  "https://cognniautomations-my.sharepoint.com/financeforms",
  "https://cognniautomations-my.sharepoint.com/legalrecords",
  "https://cognniautomations-my.sharepoint.com/hrrecords",
  "https://cognniautomations-my.sharepoint.com/financerecords",
  "https://cognniautomations-my.sharepoint.com/legalmanagement",
  "https://cognniautomations-my.sharepoint.com/hrmanagement",
  "https://cognniautomations-my.sharepoint.com/financemanagement",
  "https://cognniautomations-my.sharepoint.com/legalanalytics",
  "https://cognniautomations-my.sharepoint.com/hranalytics",
  "https://cognniautomations-my.sharepoint.com/financeanalytics",
  "https://cognniautomations-my.sharepoint.com/legaltrainingmaterials",
];

const PRIVATE_EXTERNALLY_EXPOSED_NAMES = [
  "Legal Procedures",
  "HR Procedures",
  "Finance Procedures",
  "Legal Forms",
  "HR Forms",
  "Finance Forms",
  "Legal Records",
  "HR Records",
  "Finance Records",
  "Legal Management",
  "HR Management",
  "Finance Management",
  "Legal Analytics",
  "HR Analytics",
  "Finance Analytics",
  "Legal Training Materials",
];

const PRIVATE_MASS_EXPOSED_AND_EXTERNAL_SITES = [
  "https://cognniautomations-my.sharepoint.com/legalpolicies",
  "https://cognniautomations-my.sharepoint.com/legaltraining",
  "https://cognniautomations-my.sharepoint.com/legalcompliance",
  "https://cognniautomations-my.sharepoint.com/legaldocuments",
  "https://cognniautomations-my.sharepoint.com/legalbenefits",
  "https://cognniautomations-my.sharepoint.com/legalhandbook",
  "https://cognniautomations-my.sharepoint.com/legalrecords",
  "https://cognniautomations-my.sharepoint.com/legalprocedures",
  "https://cognniautomations-my.sharepoint.com/legalforms",
  "https://cognniautomations-my.sharepoint.com/legaldirectory",
  "https://cognniautomations-my.sharepoint.com/legalmanagement",
  "https://cognniautomations-my.sharepoint.com/legalanalytics",
  "https://cognniautomations-my.sharepoint.com/legaltrainingmaterials",
  "https://cognniautomations-my.sharepoint.com/legalrecruitment",
  "https://cognniautomations-my.sharepoint.com/legalperformance",
  "https://cognniautomations-my.sharepoint.com/legaldevelopment",
  "https://cognniautomations-my.sharepoint.com/legalportal",
  "https://cognniautomations-my.sharepoint.com/legalworkflow",
  "https://cognniautomations-my.sharepoint.com/legalcommunications",
  "https://cognniautomations-my.sharepoint.com/legalconsulting",
  "https://cognniautomations-my.sharepoint.com/legalstrategies",
];

const PRIVATE_MASS_EXPOSED_AND_EXTERNAL_SITES_NAMES = [
  "Legal Policies",
  "Legal Training",
  "Legal Compliance",
  "Legal Documents",
  "Legal Benefits",
  "Legal Handbook",
  "Legal Records",
  "Legal Procedures",
  "Legal Forms",
  "Legal Directory",
  "Legal Management",
  "Legal Analytics",
  "Legal Training Materials",
  "Legal Recruitment",
  "Legal Performance",
  "Legal Development",
  "Legal Portal",
  "Legal Workflow",
  "Legal Communications",
  "Legal Consulting",
  "Legal Strategies",
];

const PUBLIC_EXTERNALLY_EXPOSED_SITES = [
  "https://cognniautomations-my.sharepoint.com/legalprograms",
  "https://cognniautomations-my.sharepoint.com/legalinitiatives",
  "https://cognniautomations-my.sharepoint.com/legalreports",
  "https://cognniautomations-my.sharepoint.com/financereports",
  "https://cognniautomations-my.sharepoint.com/hrreports",
  "https://cognniautomations-my.sharepoint.com/legaldocuments",
  "https://cognniautomations-my.sharepoint.com/hrdocuments",
  "https://cognniautomations-my.sharepoint.com/financedocuments",
];

const PUBLIC_EXTERNALLY_EXPOSED_SITES_NAMES = [
  "Legal Programs",
  "Legal Initiatives",
  "Legal Reports",
  "Finance Reports",
  "HR Reports",
  "Legal Documents",
  "HR Documents",
  "Finance Documents",
];

const FINANCIAL_FILES_NAMES = [
  "Reports.xlsx",
  "Analytics.xlsx",
  "Budget.xlsx",
  "Forecast.xlsx",
  "BalanceSheet.xlsx",
  "Audit.xlsx",
  "Inventory.xlsx",
  "CashFlow.xlsx",
  "FinancialStatements.xlsx",
  "Presentation.pptx",
  "Investment.xlsx",
  "TaxDocumentation.xlsx",
  "Payroll.xlsx",
  "FinancialProjection.xlsx",
  "CostAnalysis.xlsx",
  "FinancialModeling.xlsx",
  "FinancialPlanning.xlsx",
  "BusinessPlan.xlsx",
  "CashFlowAnalysis.xlsx",
  "RiskManagement.xlsx",
  "ProfitLossStatement.xlsx",
  "Budgeting.xlsx",
  "InvestmentStrategy.xlsx",
  "InvestmentPortfolio.xlsx",
  "ExpenseReport.xlsx",
  "FinancialReport.xlsx",
  "FinancialAnalysis.xlsx",
  "MarketAnalysis.xlsx",
  "BudgetProposal.xlsx",
  "QuarterlyReport.xlsx",
  "CashFlowStatement.xlsx",
  "BalanceSheetAnalysis.xlsx",
  "FinancialForecast.xlsx",
  "ProfitMarginAnalysis.xlsx",
  "AnnualReport.xlsx",
  "BudgetTracker.xlsx",
  "FinancialOverview.xlsx",
  "SalesForecast.xlsx",
  "CashFlowProjection.xlsx",
  "CostBenefitAnalysis.xlsx",
  "LossPrevention.xlsx",
  "RevenueForecast.xlsx",
  "BreakEvenAnalysis.xlsx",
  "AssetManagement.xlsx",
  "InvestmentAnalysis.xlsx",
  "FinancialPerformance.xlsx",
  "FinancialSummary.xlsx",
  "CostReduction.xlsx",
  "ProfitAnalysis.xlsx",
  "BudgetReview.xlsx",
  "FinancialStrategy.xlsx",
  "FinancialProjections.xlsx",
  "FinancialRiskAnalysis.xlsx",
  "FinancialPlan.xlsx",
  "BudgetSummary.xlsx",
  "CashFlowForecast.xlsx",
  "CashFlowManagement.xlsx",
  "BudgetManagement.xlsx",
  "RevenueAnalysis.xlsx",
  "BalanceSheetReview.xlsx",
  "FinancialForecasting.xlsx",
  "CostManagement.xlsx",
  "FinancialEvaluation.xlsx",
  "FinancialStability.xlsx",
  "CashManagement.xlsx",
  "FinancialMonitoring.xlsx",
  "BudgetAnalysis.xlsx",
  "ProfitabilityAnalysis.xlsx",
  "CapitalBudgeting.xlsx",
  "FinancialControl.xlsx",
  "BudgetForecast.xlsx",
  "FinancialReview.xlsx",
  "RiskAssessment.xlsx",
  "CreditAnalysis.xlsx",
  "FinancialPosition.xlsx",
  "FinancialStrategyPlanning.xlsx",
  "FinancialStrategyDevelopment.xlsx",
  "CashFlowForecasting.xlsx",
  "FinancialPerformanceAnalysis.xlsx",
  "FinancialDecisionMaking.xlsx",
  "FinancialHealth.xlsx",
  "FinancialOutlook.xlsx",
  "BudgetImplementation.xlsx",
  "FinancialForecastAnalysis.xlsx",
  "FinancialReporting.xlsx",
  "ProfitabilityAssessment.xlsx",
  "FinancialPlanningAnalysis.xlsx",
  "BudgetProjection.xlsx",
  "FinancialRiskManagement.xlsx",
  "FinancialControlAnalysis.xlsx",
  "FinancialStrategyEvaluation.xlsx",
  "FinancialManagement.xlsx",
  "FinancialStrategyImplementation.xlsx",
  "FinancialProjectionAnalysis.xlsx",
  "FinancialAnalysisReport.xlsx",
  "FinancialPolicy.xlsx",
  "FinancialGoalSetting.xlsx",
  "FinancialRiskAssessment.xlsx",
  "FinancialForecastReview.xlsx",
  "FinancialPlanningReport.xlsx",
  "FinancialRiskReview.xlsx",
  "FinancialStrategyAssessment.xlsx",
  "FinancialPlanReview.xlsx",
  "FinancialControlReview.xlsx",
  "FinancialPerformanceReview.xlsx",
  "FinancialStrategyReview.xlsx",
  "FinancialManagementReview.xlsx",
  "FinancialDecisionReview.xlsx",
  "FinancialGoalReview.xlsx",
  "FinancialRiskReport.xlsx",
  "FinancialForecastAssessment.xlsx",
  "FinancialPlanAssessment.xlsx",
  "FinancialStrategyReport.xlsx",
  "FinancialProjectionReview.xlsx",
  "FinancialAnalysisAssessment.xlsx",
  "FinancialPolicyReview.xlsx",
  "FinancialGoalAssessment.xlsx",
  "FinancialDecisionAssessment.xlsx",
  "FinancialRiskAssessmentReport.xlsx",
  "FinancialForecastAssessmentReport.xlsx",
];

const HR_FILE_NAMES = [
  "EmployeeHandbook.docx",
  "HR_Policies.docx",
  "HR_Procedures.docx",
  "HR_Training.docx",
  "HR_Recruitment.docx",
  "PerformanceAppraisal.docx",
  "JobDescriptions.docx",
  "HR_Manual.docx",
  "HR_Forms.docx",
  "HR_Records.docx",
  "HR_Directory.docx",
  "HR_Strategies.docx",
  "HR_Guidelines.docx",
  "HR_Reports.docx",
  "HR_Evaluation.docx",
  "HR_Benefits.docx",
  "HR_HealthSafety.docx",
  "HR_HiringProcess.docx",
  "HR_EmployeeRelations.docx",
  "HR_LegalCompliance.docx",
  "HR_TrainingMaterials.docx",
  "HR_Communications.docx",
  "HR_RecruitmentGuide.docx",
  "HR_SalaryStructure.docx",
  "HR_PerformanceManagement.docx",
  "HR_CompensationBenefits.docx",
  "HR_OnboardingProcess.docx",
  "HR_WorkplacePolicies.docx",
  "HR_EmployeeEngagement.docx",
  "HR_TalentManagement.docx",
  "HR_LeaveManagement.docx",
  "HR_DevelopmentPrograms.docx",
  "HR_TerminationProcedures.docx",
  "HR_PayrollProcessing.docx",
  "HR_TimeTracking.docx",
  "HR_WorkforcePlanning.docx",
  "HR_RetentionStrategies.docx",
  "HR_DiversityInclusion.docx",
  "HR_PerformanceMetrics.docx",
  "HR_TrainingDevelopment.docx",
  "HR_WorkplaceWellness.docx",
  "HR_SuccessionPlanning.docx",
  "HR_EmployeeHandbooks.docx",
  "HR_OrganizationalDevelopment.docx",
  "HR_CareerDevelopment.docx",
  "HR_EmployeeEngagementSurvey.docx",
  "HR_RecruitmentStrategies.docx",
  "HR_WorkplaceSafety.docx",
  "HR_EmployeeBenefits.docx",
  "HR_PerformanceReview.docx",
  "HR_JobAnalysis.docx",
  "HR_InterviewGuidelines.docx",
  "HR_TalentAcquisition.docx",
  "HR_PolicyManual.docx",
  "HR_CorporateCulture.docx",
  "HR_TerminationProcess.docx",
  "HR_WorkplaceTraining.docx",
  "HR_StaffDevelopment.docx",
  "HR_EmployeeHandbookPolicies.docx",
  "HR_PayrollManagement.docx",
  "HR_RecruitmentProcess.docx",
  "HR_EmployeeRetention.docx",
  "HR_PerformanceAppraisalForms.docx",
  "HR_TeamBuildingActivities.docx",
  "HR_EmployeeEngagementPrograms.docx",
  "HR_StaffTraining.docx",
  "HR_WorkplaceHarassment.docx",
  "HR_EmployeeSatisfactionSurvey.docx",
  "HR_RecruitmentChecklist.docx",
  "HR_JobDescriptionsTemplates.docx",
  "HR_RecruitmentAdvertising.docx",
  "HR_TerminationLetter.docx",
  "HR_CompensationPlan.docx",
  "HR_EmployeeRecognitionProgram.docx",
  "HR_DisciplinaryActionForms.docx",
  "HR_EmployeeFeedbackForm.docx",
  "HR_WorkplaceConflictResolution.docx",
  "HR_PerformanceImprovementPlan.docx",
  "HR_SalaryReviewProcess.docx",
  "HR_OrientationProgram.docx",
  "HR_EmployeeSurvey.docx",
  "HR_TalentRetentionStrategy.docx",
  "HR_CompensationReview.docx",
  "HR_JobOfferLetter.docx",
  "HR_PerformanceEvaluation.docx",
  "HR_CareerPathPlanning.docx",
  "HR_WorkplaceFlexibilityPolicy.docx",
  "HR_RecruitmentPolicy.docx",
  "HR_ExitInterviewForm.docx",
  "HR_EmployeeEngagementIdeas.docx",
  "HR_JobPerformanceEvaluation.docx",
  "HR_EmployeeTrainingProgram.docx",
  "HR_PerformanceManagementSystem.docx",
  "HR_CareerDevelopmentPlan.docx",
  "HR_EmployeeWellnessProgram.docx",
  "HR_SalarySurvey.docx",
  "HR_EmployeeHandbookTemplate.docx",
  "HR_PayrollSystem.docx",
];

const LEGAL_FILE_NAMES = [
  "Legal_Agreement.docx",
  "Legal_Contract.pdf",
  "Legal_Policies.xlsx",
  "Legal_Reports.docx",
  "Legal_Forms.pdf",
  "Legal_Terms.xlsx",
  "Legal_Regulations.docx",
  "Legal_Procedures.pdf",
  "Legal_Handbook.xlsx",
  "Legal_Documents.docx",
  "Legal_Records.pdf",
  "Legal_Policy.docx",
  "Legal_Letters.pdf",
  "Legal_Guidelines.xlsx",
  "Legal_Notices.docx",
  "Legal_Compliance.pdf",
  "Legal_Templates.xlsx",
  "Legal_AgreementTemplate.docx",
  "Legal_ContractTemplate.pdf",
  "Legal_PoliciesTemplate.xlsx",
  "Legal_ReportsTemplate.docx",
  "Legal_FormsTemplate.pdf",
  "Legal_TermsTemplate.xlsx",
  "Legal_RegulationsTemplate.docx",
  "Legal_ProceduresTemplate.pdf",
  "Legal_HandbookTemplate.xlsx",
  "Legal_DocumentsTemplate.docx",
  "Legal_RecordsTemplate.pdf",
  "Legal_PolicyTemplate.xlsx",
  "Legal_LettersTemplate.docx",
  "Legal_GuidelinesTemplate.pdf",
  "Legal_NoticesTemplate.xlsx",
  "Legal_ComplianceTemplate.docx",
  "Legal_TemplatesTemplate.pdf",
  "Legal_AgreementFormat.xlsx",
  "Legal_ContractFormat.docx",
  "Legal_PoliciesFormat.pdf",
  "Legal_ReportsFormat.xlsx",
  "Legal_FormsFormat.docx",
  "Legal_TermsFormat.pdf",
  "Legal_RegulationsFormat.xlsx",
  "Legal_ProceduresFormat.docx",
  "Legal_HandbookFormat.pdf",
  "Legal_DocumentsFormat.xlsx",
  "Legal_RecordsFormat.docx",
  "Legal_PolicyFormat.pdf",
  "Legal_LettersFormat.xlsx",
  "Legal_GuidelinesFormat.docx",
  "Legal_NoticesFormat.pdf",
  "Legal_ComplianceFormat.xlsx",
  "Legal_TemplatesFormat.docx",
  "Legal_AgreementDraft.pdf",
  "Legal_ContractDraft.xlsx",
  "Legal_PoliciesDraft.docx",
  "Legal_ReportsDraft.pdf",
  "Legal_FormsDraft.xlsx",
  "Legal_TermsDraft.docx",
  "Legal_RegulationsDraft.pdf",
  "Legal_ProceduresDraft.xlsx",
  "Legal_HandbookDraft.docx",
  "Legal_DocumentsDraft.pdf",
  "Legal_RecordsDraft.xlsx",
  "Legal_PolicyDraft.docx",
  "Legal_LettersDraft.pdf",
  "Legal_GuidelinesDraft.xlsx",
  "Legal_NoticesDraft.docx",
  "Legal_ComplianceDraft.pdf",
  "Legal_TemplatesDraft.xlsx",
  "Legal_AgreementReview.docx",
  "Legal_ContractReview.pdf",
  "Legal_PoliciesReview.xlsx",
  "Legal_ReportsReview.docx",
  "Legal_FormsReview.pdf",
  "Legal_TermsReview.xlsx",
  "Legal_RegulationsReview.docx",
  "Legal_ProceduresReview.pdf",
  "Legal_HandbookReview.xlsx",
  "Legal_DocumentsReview.docx",
  "Legal_RecordsReview.pdf",
  "Legal_PolicyReview.xlsx",
  "Legal_LettersReview.docx",
  "Legal_GuidelinesReview.pdf",
  "Legal_NoticesReview.xlsx",
  "Legal_ComplianceReview.docx",
  "Legal_TemplatesReview.pdf",
  "Legal_AgreementAnalysis.xlsx",
  "Legal_ContractAnalysis.docx",
  "Legal_PoliciesAnalysis.pdf",
  "Legal_ReportsAnalysis.xlsx",
  "Legal_FormsAnalysis.docx",
  "Legal_TermsAnalysis.pdf",
  "Legal_RegulationsAnalysis.xlsx",
  "Legal_ProceduresAnalysis.docx",
  "Legal_HandbookAnalysis.pdf",
  "Legal_DocumentsAnalysis.xlsx",
  "Legal_RecordsAnalysis.docx",
  "Legal_PolicyAnalysis.pdf",
  "Legal_LettersAnalysis.xlsx",
  "Legal_GuidelinesAnalysis.docx",
  "Legal_NoticesAnalysis.pdf",
  "Legal_ComplianceAnalysis.xlsx",
  "Legal_TemplatesAnalysis.docx",
  "Legal_AgreementSummary.pdf",
  "Legal_ContractSummary.xlsx",
  "Legal_PoliciesSummary.docx",
  "Legal_ReportsSummary.pdf",
  "Legal_FormsSummary.xlsx",
  "Legal_TermsSummary.docx",
  "Legal_RegulationsSummary.pdf",
  "Legal_ProceduresSummary.xlsx",
  "Legal_HandbookSummary.docx",
  "Legal_DocumentsSummary.pdf",
];

const BUSINESS_FILE_NAMES = [
  "Plan.docx",
  "Strategy.pdf",
  "Model.xlsx",
  "Proposal.docx",
  "Analysis.pdf",
  "Report.xlsx",
  "Development.docx",
  "Presentation.pdf",
  "Financials.xlsx",
  "MarketingPlan.docx",
  "CaseStudy.pdf",
  "Budget.xlsx",
  "Policies.docx",
  "PartnershipAgreement.pdf",
  "Inventory.xlsx",
  "SalesForecast.docx",
  "SustainabilityReport.pdf",
  "BalanceSheet.xlsx",
  "MarketResearch.docx",
  "ExecutiveSummary.pdf",
  "ProjectProposal.xlsx",
  "StrategicPlan.docx",
  "FinancialReport.pdf",
  "ProcessImprovement.xlsx",
  "OperationsManual.docx",
  "MergerAcquisition.pdf",
  "CashFlowStatement.xlsx",
  "PerformanceReview.docx",
  "CorporateGovernance.pdf",
  "RiskAssessment.xlsx",
  "LogisticsPlan.docx",
  "FinancialProjection.pdf",
  "TechnicalManual.xlsx",
  "MarketAnalysis.docx",
  "ProductCatalog.pdf",
  "ProfitLossStatement.xlsx",
  "HumanResourcesPlan.docx",
  "InvestmentAnalysis.pdf",
  "SupplyChainManagement.xlsx",
  "TrainingManual.docx",
  "ExpenseReport.pdf",
  "MarketingStrategy.xlsx",
  "CustomerServicePolicy.docx",
  "TaxDocumentation.pdf",
  "SalesPlan.xlsx",
  "FinancialStatement.docx",
  "CustomerFeedbackSurvey.pdf",
  "QualityAssurance.xlsx",
  "ProductDevelopmentPlan.docx",
  "PublicRelationsStrategy.pdf",
  "BusinessContinuityPlan.xlsx",
  "CommunicationsProtocol.docx",
  "EnvironmentalImpactReport.pdf",
  "SocialMediaStrategy.xlsx",
  "EmployeeManual.docx",
  "EthicsPolicy.pdf",
  "ResearchProposal.xlsx",
  "CrisisManagementPlan.docx",
  "FinancialForecast.pdf",
  "SupplierAgreement.xlsx",
  "SalesContract.docx",
  "MarketingCampaign.pdf",
  "TechnologyPlan.xlsx",
  "OperationsReview.docx",
  "CorporateSocialResponsibility.pdf",
  "FranchiseAgreement.xlsx",
  "CustomerRetentionPlan.docx",
  "ProductLaunch.pdf",
  "PaymentTerms.xlsx",
  "SalesPresentation.docx",
  "BrandingStrategy.pdf",
  "InventoryManagement.xlsx",
];

const GOVERNANCE_FILE_NAMES = [
  "Policy.docx",
  "Framework.pdf",
  "Manual.xlsx",
  "Procedures.docx",
  "Standards.pdf",
  "Guidelines.xlsx",
  "Reports.docx",
  "Compliance.pdf",
  "Charter.xlsx",
  "CodeofConduct.docx",
  "Regulations.pdf",
  "Bylaws.xlsx",
  "Directives.docx",
  "Oversight.pdf",
  "Assessment.xlsx",
  "Framework.docx",
  "Manual.pdf",
  "Procedures.xlsx",
  "Standards.docx",
  "Guidelines.pdf",
  "Reports.xlsx",
  "Compliance.docx",
  "Charter.pdf",
  "CodeofConduct.xlsx",
  "Regulations.docx",
  "Bylaws.pdf",
  "Directives.xlsx",
  "Oversight.docx",
  "Assessment.pdf",
  "Framework.docx",
  "Manual.pdf",
  "Procedures.xlsx",
  "Standards.docx",
  "Guidelines.pdf",
  "Reports.xlsx",
  "Compliance.docx",
  "Charter.pdf",
  "CodeofConduct.xlsx",
  "Regulations.docx",
  "Bylaws.pdf",
  "Directives.xlsx",
  "Oversight.docx",
  "Assessment.pdf",
  "Framework.docx",
  "Manual.pdf",
  "Procedures.xlsx",
  "Standards.docx",
  "Guidelines.pdf",
  "Reports.xlsx",
  "Compliance.docx",
  "Charter.pdf",
  "CodeofConduct.xlsx",
  "Regulations.docx",
  "Bylaws.pdf",
  "Directives.xlsx",
  "Oversight.docx",
  "Assessment.pdf",
  "Framework.docx",
  "Manual.pdf",
  "Procedures.xlsx",
  "Standards.docx",
  "Guidelines.pdf",
  "Reports.xlsx",
  "Compliance.docx",
  "Charter.pdf",
  "CodeofConduct.xlsx",
  "Regulations.docx",
  "Bylaws.pdf",
  "Directives.xlsx",
  "Oversight.docx",
  "Assessment.pdf",
  "Framework.docx",
  "Manual.pdf",
  "Procedures.xlsx",
  "Standards.docx",
  "Guidelines.pdf",
  "Reports.xlsx",
  "Compliance.docx",
  "Charter.pdf",
  "CodeofConduct.xlsx",
  "Regulations.docx",
  "Bylaws.pdf",
  "Directives.xlsx",
  "Oversight.docx",
  "Assessment.pdf",
  "Framework.docx",
  "Manual.pdf",
  "Procedures.xlsx",
  "Standards.docx",
  "Guidelines.pdf",
  "Reports.xlsx",
  "Compliance.docx",
  "Charter.pdf",
  "CodeofConduct.xlsx",
  "Regulations.docx",
  "Bylaws.pdf",
  "Directives.xlsx",
  "Oversight.docx",
  "Assessment.pdf",
  "Framework.docx",
  "Manual.pdf",
  "Procedures.xlsx",
  "Standards.docx",
  "Guidelines.pdf",
  "Reports.xlsx",
  "Compliance.docx",
  "Charter.pdf",
  "CodeofConduct.xlsx",
  "Regulations.docx",
  "Bylaws.pdf",
  "Directives.xlsx",
  "Oversight.docx",
  "Assessment.pdf",
  "Framework.docx",
  "Manual.pdf",
  "Procedures.xlsx",
  "Standards.docx",
];

export const get_file_names_for_l0 = (code: number): string[] => {
  switch (code) {
    case 2: //"2ef1d9da-0ad7-450e-4b09-efd43581ce78":
      return GOVERNANCE_FILE_NAMES;
    case 3: //"e2bd11ab-9869-5adc-f11c-7d05c7c6fc2b":
      return BUSINESS_FILE_NAMES;
    case 4: // "fd6a3357-4b1f-df40-d9f5-731e35302fe5":
      return FINANCIAL_FILES_NAMES;
    case 5: //"707babad-231f-82bb-014c-8506d3dc784e":
      return HR_FILE_NAMES;
    case 6:
    default:
      return LEGAL_FILE_NAMES;
  }
  /*  case 6: //"e34ebd2f-cd96-22ac-3059-952a7fe01e54": */
  /*    return LEGAL_FILE_NAMES; */
  /*  case 7: //"a9383d32-7694-4d84-b37c-79afb945505b": */
};

export const get_sites_name_for_permission_type = (
  main_type: PermissionMainType,
  sub_type: PermissionSubType
): Array<[string, string, string]> => {
  const key = PermissionTypeHelper.to_key(main_type, sub_type);
  switch (true) {
    case key == PermissionTypeHelper.to_key("private", "externally_exposed"):
      return zip<string>(
        PRIVATE_EXTERNALLY_EXPOSED,
        PRIVATE_EXTERNALLY_EXPOSED_NAMES,
        OWNERS
      );
    case key == PermissionTypeHelper.to_key("private", "mass_exposed"):
      return zip<string>(
        PRIVATE_MASS_EXPOSED_SITES,
        PRIVATE_MASS_EXPOSED_SITES_NAMES,
        OWNERS
      );
    case key ==
      PermissionTypeHelper.to_key("private", "mass_and_externally_exposed"):
      return zip<string>(
        PRIVATE_MASS_EXPOSED_AND_EXTERNAL_SITES,
        PRIVATE_MASS_EXPOSED_AND_EXTERNAL_SITES_NAMES,
        OWNERS
      );
    case key == PermissionTypeHelper.to_key("private", "not_mass_exposed"):
      return zip<string>(PRIVATE_SITES, PRIVATE_SITES_NAMES, OWNERS);
    case key == PermissionTypeHelper.to_key("public", "not_mass_exposed"):
      return zip<string>(PUBLIC_SITES, PUBLIC_SITES_NAMES, OWNERS);
    case key == PermissionTypeHelper.to_key("public", "externally_exposed"):
    default:
      return zip<string>(
        PUBLIC_EXTERNALLY_EXPOSED_SITES,
        PUBLIC_EXTERNALLY_EXPOSED_SITES_NAMES,
        OWNERS
      );
  }
};

export const get_files_count_for_l0 = (code: number): number => {
  switch (code) {
    case 2: //"2ef1d9da-0ad7-450e-4b09-efd43581ce78":
      return GOVERNANCE_FILE_NAMES.length;
    case 3: //"e2bd11ab-9869-5adc-f11c-7d05c7c6fc2b":
      return BUSINESS_FILE_NAMES.length;
    case 4: // "fd6a3357-4b1f-df40-d9f5-731e35302fe5":
      return FINANCIAL_FILES_NAMES.length;
    case 5: //"707babad-231f-82bb-014c-8506d3dc784e":
      return HR_FILE_NAMES.length;
    case 6:
    default:
      return LEGAL_FILE_NAMES.length;
  }
};
